import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3ed1b2bb&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=3ed1b2bb&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1b2bb",
  null
  
)

export default component.exports